import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { DO_NOT_CHANGE_NUM_RETRIES, DO_NOT_CHANGE_TIMEOUT, REASON, } from '#pplx/frontend/apps/ask/finance/queries/constants.js';
import { QueryClientHelper } from '#pplx/frontend/react-query/QueryClientHelper.js';
import { financeClient } from '#pplx_generated/typespec/rest/finance/client.js';
export const getNewswireDocumentByDocumentIdKey = (documentId) => {
    return QueryClientHelper.makeEphemeralQueryKey('finance/newswire-document/by-document-id', documentId);
};
export async function getNewswireDocumentByDocumentId({ documentId, }) {
    const { data, error, response } = await financeClient.GET('/rest/finance/financial-news/documents/{document_id}', REASON, {
        params: {
            path: {
                document_id: documentId,
            },
        },
        timeoutMs: DO_NOT_CHANGE_TIMEOUT,
        numRetries: DO_NOT_CHANGE_NUM_RETRIES,
    });
    if (error) {
        throw new ApiClientsError('API_CLIENTS_ERROR', {
            cause: error,
            status: response.status ?? 0,
        });
    }
    return data;
}
//# sourceMappingURL=getNewswireDocumentByDocumentId.js.map